module.exports = __webpack_public_path__ + "static/media/06.111.23173185.webp";